<sb-modal-header modalTitle="SB_Transactions" (onClose)="close()"></sb-modal-header>
<div class="modal-body">
  <div class="container-fluid form-horizontal">

    @if (loading === 0 && accountData) {

      <h2 [innerHTML]="'SB_Transactions_for_name' | translate: { name: accountData.accountHolderName }"></h2>
      <span [innerHTML]="'SB_x_transactions' | translate: { x: numberOfTransactions }"></span>

      <div class="form-group">
        <label class="control-label col-sm-4" [innerHTML]="'SB_From' | translate"></label>
        <div class="col-sm-8">
          <sb-date-picker
            name="searchFrom"
            [(modelDate)]="search.from"></sb-date-picker>
        </div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-4" [innerHTML]="'SB_To' | translate"></label>
        <div class="col-sm-8">
          <sb-date-picker
            name="searchTo"
            [minDate]="search.from"
            [(modelDate)]="search.to"></sb-date-picker>
        </div>
      </div>

      <div class="form-group">
        <div class="col-sm-push-4 col-sm-8">
          <button class="btn btn-default"
                  (click)="tryAndGetTransactions()"
                  [innerHTML]="'SB_Get_Transactions' | translate">
          </button>
        </div>
      </div>

      <div class="form-group" id="transaction-view-show-source-transactions">
        <div class="col-sm-push-4 col-sm-8">
          <sb-check-box [(model)]="showSourceTransactions"
                        controlName="showSourceTransactions"
                        [trueValue]="true"
                        [falseValue]="false"
                        label="SB_Show_Source_Transactions"
                        (onClick)="fetchSource()"></sb-check-box>
        </div>
      </div>

      <div class="control-group">
        <div class="input-group">
          <span class="input-group-addon"><sb-icon name="search"></sb-icon></span>
          <input [(ngModel)]="search.text"
                 type="text"
                 class="form-control"
                 id="inputGroupSuccess1"
                 aria-describedby="inputGroupSuccess1Status">
          <span class="input-group-btn">
            <button class="btn btn-default"
                    (click)="tryAndGetTransactions()">
              <sb-icon name="refresh"></sb-icon>
              <span [innerHTML]="'SB_Refresh' | translate"></span>
            </button>
          </span>
        </div>
      </div>

      <div class="table-responsive mt-5">
        <table class="table table-striped table-condensed">
          <thead>
            <tr>
              <th>
                <sb-column-header label="SB_Date"
                                  fieldName="date"
                                  [(sortType)]="sortType"
                                  [(sortReverse)]="sortReverse"></sb-column-header>
              </th>
              <th>
                <span [innerHTML]="'SB_Description' | translate"></span>
              </th>
              <th [innerHTML]="'SB_Credit' | translate"></th>
              <th [innerHTML]="'SB_Debit' | translate"></th>
              <th [innerHTML]="'SB_Balance' | translate"></th>
            </tr>
          </thead>
          <tbody>
            @for (transaction of filteredTransactions(); track transaction.id) {
              <tr>
                <td>
                  @if (!transaction.isOpeningBalance) {
                    <span [innerHTML]="transaction.date | date: 'dd MMM yyyy'"></span>
                  }
                </td>
                <td>
                  @if (!transaction.isOpeningBalance) {
                    <span [innerHTML]="transaction.description"></span>
                    @if (transaction.reference && transaction.reference !== '') {
                      <span>({{ transaction.reference }})</span>
                    }
                  }
                  @if (transaction.isOpeningBalance) {
                    <span [innerHTML]="'SB_Opening_Balance' | translate"></span>
                  }
                </td>
                <td>
                  @if (!transaction.isOpeningBalance) {
                    <span>{{ formatCurrency(transaction.credit) }}</span>
                  }
                </td>
                <td>
                  @if (!transaction.isOpeningBalance) {
                    <span>{{ formatCurrency(transaction.debit) }}</span>
                  }
                </td>
                <td [ngClass]="{ 'text-danger': transaction.balance < 0 }">
                  <span>{{ formatCurrency(transaction.balance) }}</span>
                  @if (transaction.balancePendingUpdate) {
                    <sb-icon name="warning"
                             [ngbTooltip]="'SB_Balance_Update_Warning' | translate"></sb-icon>
                  }
                </td>
              </tr>
              @if (showRelatedTransactions) {
                @for (relatedTransaction of transaction.relatedTransactions; track relatedTransaction.id) {
                  <tr class="info">
                    <td><small [innerHTML]="relatedTransaction.date | date: 'dd MMM yyyy'"></small></td>
                    <td><small [innerHTML]="relatedTransaction.description"></small></td>
                    <td><small>{{ formatCurrency(relatedTransaction.credit) }}</small></td>
                    <td><small>{{ formatCurrency(relatedTransaction.debit) }}</small></td>
                    <td>&nbsp;</td>
                  </tr>
                }
              }
              @if (showSourceTransactions) {
                @for (sourceTransaction of transaction.sourceTransactions; track sourceTransaction.id) {
                  <tr class="warning">
                    <td><small [innerHTML]="sourceTransaction.date | date: 'dd MMM yyyy'"></small></td>
                    <td><small [innerHTML]="sourceTransaction.description"></small></td>
                    <td><small>{{ formatCurrency(sourceTransaction.credit) }}</small></td>
                    <td><small>{{ formatCurrency(sourceTransaction.debit) }}</small></td>
                    <td>&nbsp;</td>
                  </tr>
                }
              }
            }
          </tbody>
        </table>
      </div>
    }

    @if (loading < 1 && accountData && accountData.transactions.length === 0) {
      <div class="alert alert-info rhythm-m-t-1" role="alert">
        <p [innerHTML]="'SB_No_transactions_found' | translate"></p>
      </div>
    }

    @if (loading > 0) {
      <div class="loading">
        <sb-icon name="loading"></sb-icon>
        <span [innerHTML]="'SB_Loading' | translate"></span>
      </div>
    }

  </div>
</div>
